module.exports = __webpack_public_path__ + "img/start_button.96ab862d.png";